import { buildFormData } from "./payload.helper";

const ALLOWED_FIELDS = [
    "patient_id",
    "remarks",
    "report_type_id",
    "status",
    "attachments",
    "existing_attachments",
];

const pickFields = (data) =>
    ALLOWED_FIELDS.reduce((acc, key) => {
        if (data[key] !== undefined) {
            acc[key] = data[key];
        }
        return acc;
    }, {});

const labReportHelper = {
    forCreate: (data) => buildFormData(pickFields(data)),
    forUpdate: (id, data) => ({
        id,
        body: buildFormData(pickFields(data)),
    }),
};

export default labReportHelper;